module.exports = __webpack_public_path__ + "static/img/packet.bfa843d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packet.png
// module id = hU08
// module chunks = 2